import React, { createRef, PropsWithChildren, ReactElement } from 'react'
import useGetColorMode from 'utils/useGetColorMode'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'
import { Flex } from 'theme-ui'

export const scrollingFiltersContainerRef = createRef<HTMLDivElement>()

export default function FiltersScrollingContainer({ children }: PropsWithChildren): ReactElement {
  const { isLightMode } = useGetColorMode()
  const isMobile = useBreakpointIndex() === 0

  return (
    <Flex
      data-testid="filters-container"
      sx={{
        width: ['100%', 'fit-content'],
        alignItems: 'center',
      }}
      className={isMobile ? 'reset-tippy-width-subheader' : ''}
    >
      <Flex
        ref={scrollingFiltersContainerRef}
        sx={{
          position: ['relative', 'static'],
          alignItems: 'center',
          flexWrap: ['nowrap', 'wrap'],
          overflowX: 'auto',
          overflowY: 'hidden',
          pb: ['0.6rem', 0],
          '::-webkit-scrollbar': {
            height: '5px',
          },
        }}
        className={`show-scrollbar ${isLightMode ? 'light' : 'dark'}`}
      >
        {children}
      </Flex>
    </Flex>
  )
}
